import React from "react";
import { Anchor, Group, ActionIcon, rem } from "@mantine/core";
import {
  IconBrandInstagram,
  IconBrandTiktok,
} from "@tabler/icons-react";
import { useNavigate, useLocation } from "react-router-dom";
import { scroller } from "react-scroll";
import classes from "./footer.module.scss";
import "./styles.scss";

const links = [
  { link: "features", label: "Hva får du?" },
  { link: "process", label: "Prosessen" },
  { link: "about", label: "Om meg" },
  { link: "contact", label: "Ta kontakt" },
  { link: "priser", label: "Priser" },
];

// Define URLs for social media profiles
const socialMediaLinks = {
  instagram: "https://www.instagram.com/henningal/",
  tiktok: "https://www.tiktok.com/@henninglangseth?lang=en",
};

export function FooterComponent() {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (link) => {
    scroller.scrollTo(link, {
      duration: 800,
      smooth: "easeInOutQuart",
      offset: -70,
    });
  };

  const handleLinkClick = (link) => {
    if (link === "priser") {
      navigate("/priser", { replace: true });
      return;
    }

    if (location.pathname !== "/") {
      navigate("/", { replace: true });
      setTimeout(() => {
        scrollToSection(link);
      }, 100);
    } else {
      scrollToSection(link);
    }
  };

  const items = links.map((link) => (
    <Anchor
      c="dimmed"
      key={link.label}
      href={`#${link.link}`}
      lh={1}
      onClick={(event) => {
        event.preventDefault();
        handleLinkClick(link.link);
      }}
      size="sm"
    >
      {link.label}
    </Anchor>
  ));

  return (
    <div className={classes.footer}>
      <div className={classes.inner}>
        <img
          src="/optimized/logo-768.webp"
          alt="Moderne Coaching"
          style={{ height: "28px" }}
          width="162"
          height="28"
          loading="lazy"
        />
        <Group className={classes.links}>{items}</Group>
        <Group gap="xs" justify="flex-end" wrap="nowrap">
          <ActionIcon
            size="lg"
            variant="default"
            radius="xl"
            aria-label="TikTok"
            onClick={() =>
              window.open(socialMediaLinks.tiktok, "_blank", "noopener,noreferrer")
            }
          >
            <IconBrandTiktok
              style={{ width: rem(18), height: rem(18) }}
              stroke={1.5}
            />
          </ActionIcon>
          <ActionIcon
            size="lg"
            variant="default"
            radius="xl"
            aria-label="Instagram"
            onClick={() =>
              window.open(socialMediaLinks.instagram, "_blank", "noopener,noreferrer")
            }
          >
            <IconBrandInstagram
              style={{ width: rem(18), height: rem(18) }}
              stroke={1.5}
            />
          </ActionIcon>
        </Group>
      </div>
      <div className={classes.copyright}>
        © {new Date().getFullYear()} Henning Langseth · Helhetlig helsecoaching
        {" · "}
        <Anchor
          c="dimmed"
          size="xs"
          href="/personvern"
          onClick={(event) => {
            event.preventDefault();
            navigate("/personvern");
            window.scrollTo(0, 0);
          }}
        >
          Personvern
        </Anchor>
        {" · "}
        {/* Statisk fil i public/ — vanlig navigasjon, ikke react-router. */}
        <Anchor c="dimmed" size="xs" href="/salgsbetingelser.html">
          Kjøpsvilkår
        </Anchor>
      </div>
    </div>
  );
}
